import { render, staticRenderFns } from "./ComparisonDetailsReportTable.vue?vue&type=template&id=364720f0&scoped=true&"
import script from "./ComparisonDetailsReportTable.vue?vue&type=script&lang=js&"
export * from "./ComparisonDetailsReportTable.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonDetailsReportTable.vue?vue&type=style&index=0&id=364720f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364720f0",
  null
  
)

export default component.exports